import React from 'react';
import PropTypes from 'prop-types';

import TriangleIcon from '../../assets/svgs/TriangleIcon';

import { SingleItemNavigationStyle } from './SingleItemNavigationStyle';

const SingleItemNavigation = ({
  theme,
  shape,
  value,
  minimum,
  maximum,
  handleChange,
}) => {
  const onClickNavigation = (newValue) => {
    let currentValue = newValue;

    if (currentValue < minimum) {
      currentValue = minimum;
    }

    if (currentValue > maximum) {
      currentValue = maximum;
    }

    handleChange(currentValue);
  };

  return (
    <SingleItemNavigationStyle className={`${theme}-theme ${shape}-shape`}>
      <button
        className="single-item-navigation-previous"
        type="button"
        disabled={value <= minimum}
        onClick={() => onClickNavigation(value - 1)}
      >
        <TriangleIcon />
      </button>
      <p className="single-item-navigation-value">{value}</p>
      <button
        className="single-item-navigation-next"
        type="button"
        disabled={value >= maximum}
        onClick={() => onClickNavigation(value + 1)}
      >
        <TriangleIcon />
      </button>
    </SingleItemNavigationStyle>
  );
};

SingleItemNavigation.propTypes = {
  theme: PropTypes.string,
  shape: PropTypes.string,
  value: PropTypes.number,
  minimum: PropTypes.number,
  maximum: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
};

SingleItemNavigation.defaultProps = {
  theme: 'default',
  shape: 'rounded',
  value: 1,
  minimum: 1,
  maximum: 1,
};

export default SingleItemNavigation;
